import { render, staticRenderFns } from "./ManagementView.vue?vue&type=template&id=67a9a209&scoped=true"
import script from "./ManagementView.vue?vue&type=script&lang=js"
export * from "./ManagementView.vue?vue&type=script&lang=js"
import style0 from "./ManagementView.vue?vue&type=style&index=0&id=67a9a209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a9a209",
  null
  
)

export default component.exports